import GenericCreateForm from "../../components/GenericCreateForm";

function CreatePresentation() {
  return (
    <GenericCreateForm
      title="Presentacion"
      endpoint="/presentations"
      backTo="/presentations"
    />
  );
}

export default CreatePresentation;
